import { useState } from 'react';

function setValue<T>(key: string, value: T) {
	localStorage.setItem(key, JSON.stringify(value));
	return value;
}

function getValue<T>(key: string, defaultValue: T) {
	let stored: string;
	stored = String(localStorage.getItem(key));
	stored = stored === 'undefined' ? 'null' : stored;
	if (!stored) {
		stored = JSON.stringify(defaultValue ?? null);
		localStorage.setItem(key, stored);
	}
	return JSON.parse(stored);
}

export const useLocalStorageState = <T>(key: string, defaultValue: T) => {
	const [value, setter] = useState(getValue(key, defaultValue));
	return [
		value,
		(value: T) =>
			setter((prev: T) => {
				value = typeof value === 'function' ? value(prev) : value;
				return setValue(key, value);
			}),
	];
};
